import { FC, PropsWithChildren, ReactElement } from 'react';
import SearchProductOrchestration from './SearchProductOrchestration';
import { SearchProductDetailsProvider } from './SearchProductDetailsContext';
import { SearchProductFiltersProvider } from './SearchProductFiltersContext';
import { SearchProductQueryProvider } from './SearchProductQueryContext';
import { SearchProductSelectionsProvider } from './SearchProductSelectionsContext';

export { buildPriceRangeFilters } from './searchProductContext.utils';
export {
  initialSearchListViewDataState,
  initialSearchPictureViewDataState,
} from './searchProductContext.types';
export type { SearchProductSelectionState } from './searchProductContext.types';

export const SearchProductContextProvider: FC<PropsWithChildren> = ({ children }): ReactElement => (
  <SearchProductFiltersProvider>
    <SearchProductQueryProvider>
      <SearchProductDetailsProvider>
        <SearchProductSelectionsProvider>
          <SearchProductOrchestration />
          {children}
        </SearchProductSelectionsProvider>
      </SearchProductDetailsProvider>
    </SearchProductQueryProvider>
  </SearchProductFiltersProvider>
);
